import { actionGenerator } from '../../utils/redux/actionGenerator';
import { EListingActions } from '../../constants/actionTypes/listing';
import { IRealtorsListing } from '../../types/redux/realtors';
import { IAgenciesListing } from '../../types/redux/agencies';

export const setRealtorItems = actionGenerator<EListingActions.SET_REALTORS_ITEMS, IRealtorsListing>(
  EListingActions.SET_REALTORS_ITEMS,
);
export const setAgenciesItems = actionGenerator<EListingActions.SET_AGENCIES_ITEMS, IAgenciesListing>(
  EListingActions.SET_AGENCIES_ITEMS,
);
export const setRealtorsLoading = actionGenerator<EListingActions.SET_REALTORS_LOADING, boolean>(
  EListingActions.SET_REALTORS_LOADING,
);
export const setAgenciesLoading = actionGenerator<EListingActions.SET_AGENCIES_LOADING, boolean>(
  EListingActions.SET_AGENCIES_LOADING,
);

export type TSetRealtorItemsAction = ReturnType<typeof setRealtorItems>;
export type TSetAgenciesItemsAction = ReturnType<typeof setAgenciesItems>;
export type TSetRealtorsLoadingAction = ReturnType<typeof setRealtorsLoading>;
export type TSetAgenciesLoadingAction = ReturnType<typeof setAgenciesLoading>;

export type TListingActions =
  | TSetRealtorItemsAction
  | TSetAgenciesItemsAction
  | TSetRealtorsLoadingAction
  | TSetAgenciesLoadingAction;
